import React, { useEffect, useState } from "react";
import MenuHeroImage from "../../assets/menupageherosection.png"; // Ensure the path is correct
import MenuHeroImage2 from "../../assets/ourMenu.jpg"; // Ensure the path is correct
import NavigationMenu from "./NavigationMenu.jsx";
import MenuCardSEction from "./MenuCardSection.jsx";
import { FaMapMarkerAlt, FaSearch, FaSpinner } from "react-icons/fa";
import { MdOutlineTune } from "react-icons/md";
import { DietFilterOption } from "./DietFilterOption.jsx";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector } from "react-redux";
import Cookies from 'js-cookie'
import { selectIsLoading } from '../../redux/loadingSlice.js';
const Menu = ({menuImage}) => {
  const [activeCategoryId, setActiveCategoryId] = useState(null); // Default ID
  const [title, setActiveTitle] = useState(null); // Default ID
  const [iconSize, setIconSize] = useState(34); // Default size for large screens (lg)
  const [searchTerm, setSearchTerm] = useState(""); // State to hold the search input
  const getStatus = Cookies.get('restaurantStatus')
  console.log(getStatus);
  
  const [submittedSearch, setSubmittedSearch] = useState(""); // State for submitted data
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [loading, setLoading] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isConfirmed, setIsConfirmed] = useState(false);
 const [initialSelectedOption, setInitialSelectedOption] = useState("null");
 const [allCategory,setAllCategory]=useState(null)
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value); // Update search term as the user types
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault(); // Prevent page reload
    setSubmittedSearch(searchTerm); // Pass search term to submitted state
  };

  useEffect(() => {
    // Function to handle resizing
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIconSize(30); // Large screen (lg)
      } else if (window.innerWidth >= 768) {
        setIconSize(25); // Medium screen (md)
      } else {
        setIconSize(15); // Small screen (sm)
      }
    };

    // Set the initial size based on screen width
    handleResize();

    // Add event listener for resizing
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const togglePopup = () => {
    // setIsConfirmed(false); // Reset confirmation state when popup opens again
    setIsPopupOpen(!isPopupOpen); // Toggle the popup visibility
  };
  useEffect(() => {
    // On opening the popup, reset the selected option to the confirmed option if available
    if (!isPopupOpen) return;
    setSelectedOption(isConfirmed ? initialSelectedOption : null);
  }, [isPopupOpen, isConfirmed, initialSelectedOption]);
   const handleLoadingChange = (isLoading) => {
    setLoading(isLoading);
  };

  const setDefaultCategory = (id, categoryTitle) => {
    if (!activeCategoryId) {
      setActiveCategoryId(id);
      setActiveTitle(categoryTitle);
    }
  };
  const dietOptions = [
    { title: "Gluten-Free", isSelected: false },
    {
      title: "Dairy-Free",
      isSelected: true,
    },
    { title: "Vegan", isSelected: false },
  ];
  const handleCategoryIdChange = (id, categoryTitle) => {
    setActiveCategoryId(id); // Update the active category ID
    setActiveTitle(categoryTitle); // Set the active category title
  };
  const handleConfirm = () => {
    setIsConfirmed(true); // Mark the selection as confirmed
    setInitialSelectedOption(selectedOption); // Store the confirmed option
    setIsPopupOpen(false); // Close the popup
  };
  
    const handleClearSelection = () => {
      setSelectedOption(null); // Clear selected option
      setIsConfirmed(false); // Reset confirmation state
      setIsPopupOpen(false); // Close the popup
    };
  
    const handleSelect = (title) => {
      setSelectedOption((prevSelected) =>
        prevSelected === title ? null : title // Deselect if already selected
      );
    };
  {loading && (
    <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-50">
      <FaSpinner className="animate-spin text-4xl text-[#AF313D] " />
    </div>
  )}
  const handleMenuDataChange = (menuData) => {
    // console.log("Full menu data:", menuData);
    setAllCategory(menuData);
    // Use menuData as needed
  };

  return (
    <div className=" w-full max-w-7xl mx-auto">
   <div
  className="relative w-full  " // control height here
>
  {/* Background Image */}
  <img
    src={menuImage}
    alt="Menu Hero"
    className="w-full h-full " // keeps image clear within frame
  />

  {/* Text at the top */}
  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 text-white text-center">
    <div className="flex items-center justify-center">
    
      <div className="lg:w-[10rem] sm:w-[5rem] w-[5rem] h-[3px] bg-[#FFFFFF]"></div>

      <p className="lg:text-[76px]  text-3xl font-bold  whitespace-nowrap mx-5">
         MENU
      </p>

  
      <div className="lg:w-[10rem] sm:w-[5rem] w-[5rem] h-[3px] bg-[#FFFFFF]"></div>
    </div>
  </div>

  {/* Navigation Menu at bottom */}
  <div className="absolute left-1/2 bottom-0 transform -translate-x-1/2 translate-y-1/2 md:w-[80%] w-[95%]">
    <div className="rounded-lg">
      <NavigationMenu
        activeCategoryId={activeCategoryId}
        onCategoryChange={handleCategoryIdChange}
        onLoadingChange={handleLoadingChange}
        setDefaultCategory={setDefaultCategory}
        onMenuDataChange={handleMenuDataChange}
      />
    </div>
  </div>
</div>

      <div className="flex overflow-hidden mt-10 flex-col">
      <form
        onSubmit={handleSearchSubmit}
        className="flex items-center justify-center flex-wrap md:gap-8 gap-3 self-center mt-8 max-w-full text-xl font-semibold w-[771px] md:px-2 sm:px-4 px-8"
      >
          <div className="flex items-center justify-center bg-transparent flex-wrap body flex-auto gap-10 px-8  border-2 border-solid border-[#737373] rounded-[40px] text-[#737373] max-md:px-5 max-md:max-w-full">
            <label htmlFor="locationSearch" className="sr-only">
              Search Location
            </label>
            <input
              id="locationSearch"
              type="text"
              placeholder="SEARCH FOOD"
              value={searchTerm} // Controlled input
              onChange={handleSearchChange} // Update state on input change
              className="flex-grow bg-transparent focus:bg-transparent hover:bg-transparent md:text-xl border-[none] text-[11px] outline-none max-sm:w-[35px] placeholder:text-[8.6px] md:placeholder:text-[15.26px] max-w-full  sm:h-[25.8px] h-[25.8px] md:h-[45.77px]" // Set height to 45px
            />
            {/* Replaced the image with the location icon */}
            <FaSearch className="my-auto text-[#AD343E]" size={20} />
          </div>
          {/* <div
            className="w-[45px] lg:w-[60px] h-[26px] sm:h-[26px] md:h-[45px] lg:h-[60px] flex items-center justify-center bg-[white] rounded-full shadow-md hover:cursor-pointer"
            onClick={togglePopup}
          >
            <MdOutlineTune
              color="black"
              className="h-[14px] w-[14px] md:h-[14px] sm:w-[14px] lg:h-[34px] lg:w-[34px]"
            />
          </div> */}
          {/* Popup (Modal) */}
          {isPopupOpen && (
            <main className="fixed inset-0 w-[90%] mx-auto md:w-full flex justify-center items-center  z-50">
              <section className="flex flex-col rounded-none max-w-[747px] lg:w-[747px] bg-stone-200 shadow-lg max-h-[95vh] overflow-auto">
                {/* Close Icon */}
                <div className="flex mt-2 justify-end">
                  <div className="flex justify-center items-center lg:w-[40px] lg:h-[40px] w-[34px] h-[34px] sm:w-[38px] sm:h-[38px] bg-black text-white rounded-full ml-4 mr-0 hover:cursor-pointer">
                    <AiOutlineClose
                      className="text-white"
                      size={iconSize}
                      onClick={() => setIsPopupOpen(false)}
                    />
                  </div>
                </div>
                <header className="flex items-center w-full text-4xl font-semibold leading-none text-[#AC313C] max-md:max-w-full ">
                  {/* Centered Title */}
                  <h1 className="flex-grow text-center md:text-[45.22px]  lg:text-[50px] text-[30.52px] sm:text-[30.52px] heading font-semibold">
                    FILTER BY DIET
                  </h1>
                </header>

                <div className="flex w-[90%] justify-center mx-auto flex-col gap-4 md:w-full md:mt-6 sm:mt-0 mt-0 max-md:mt-5 items-center">
                  <p className=" mt-6 lg:text-[26px] md:text-[22.61px] body text-[15.26px] sm:text-[15.26px]  leading-0 md:leading-8 text-center text-black text-opacity-70 max-md:mt-5">
                    Click to filter the menu by dietary requirement <br />
                    and remember to let our team know <br />
                    when you order.
                  </p>
                  {dietOptions.map((option) => (
          <DietFilterOption
            key={option.id}
            title={option.title}
            isSelected={selectedOption === option.title} // Check if selected
            onSelect={() => handleSelect(option.title)} // Toggle selection
          />
        ))}

<button
  onClick={handleConfirm}
  disabled={!selectedOption} // Disable if no selection
  className="self-center w-[80%] sm:w-[80%] md:w-[80%] px-12 py-2 mt-8 lg:w-full text-3xl font-semibold text-white whitespace-nowrap bg-rose-800 max-w-[600px] rounded-[40px] max-md:px-5 max-md:mt-6 max-md:max-w-full body"
>
  Confirm
</button>


                  <button
                 onClick={handleClearSelection}
                  className=" w-[80%] sm:w-[80%] md:w-[80%] px-12 py-2 mt-8 lg:w-full text-3xl font-semibold  whitespace-nowrap text-rose-800 border-rose-800 border-solid border-[3px] max-w-[600px] rounded-[40px] max-md:px-5 max-md:mt-6 max-md:max-w-full body  mb-8">
                    Clear Selection
                  </button>
                </div>
              </section>
            </main>
          )}

          <button
            type="submit"
            className="lg:w-[122px] sm:w-[52.45px] w-[52.45px] h-[24.8px] flex items-center justify-center lg:h-[60px] md:h-[45.77px] md:w-[93px] text-white whitespace-nowrap bg-[#AF313D]  rounded-[40px] max-md:px-5"
          >
            <span className=" text-[8.6px] sm:text-[8.6px] md:text-[15.26px] lg:text-[20px] body font-semibold">
              Search
            </span>
          </button>
        </form>
        <MenuCardSEction
        activeCategoryId={activeCategoryId}
        title={title}
        searchTerm={submittedSearch}
        allCategory={allCategory}
        selectedDietOption={isConfirmed===true ? selectedOption : null} />
      </div>
    </div>
  );
};

export default Menu;
